<template>
  <router-view></router-view>
</template>

<style lang="scss">

</style>

<script>
  /**
   * Import app style
   */
  import '@/assets/sass/main.scss'

  /**
   * Import 3rd party module styles
   */
  import 'flag-icon-css/sass/flag-icon.scss'
  import 'vue-multiselect/dist/vue-multiselect.min.css'
  import 'swiper/dist/css/swiper.css'
  import 'vue-loaders/dist/vue-loaders.css';

  export default{
    name: 'TheApp'
  }

</script>



// WEBPACK FOOTER //
// src/TheApp.vue